import React from 'react';

import { Filter } from '@gogame/filters';
import { dateFNS } from '@gogame/intl-ts';

import {
  FILTER_REGISTRATION_PERIOD,
  FILTER_APPLICATIONS,
  FILTER_NETWORKS,
  FILTER_PLATFORMS,
  FILTER_AFFILIATES,
  FILTER_REAL_COUNTRIES,
  FILTER_DEPENDENCIES,
  PERIOD_PRESETS,
} from 'scenes/RegsStats/constants';
import {
  loadApplications,
  loadNetworks,
  loadPlatforms,
  loadAffiliates,
  loadRealCountries,
} from 'scenes/RegsStats/sources/filters';

export const RegistrationPeriodFilter = (props) => {
  return (
    <Filter.DateRangePicker
      title={'Registration period'}
      name={FILTER_REGISTRATION_PERIOD}
      presets={PERIOD_PRESETS}
      minDate={dateFNS.subDays(dateFNS.startOfDay(new Date()), 90)}
      maxDate={new Date()}
      required={true}
      {...props}
    />
  );
};

export const ApplicationsFilter = (props) => {
  return (
    <Filter.MultiSelect
      name={FILTER_APPLICATIONS}
      title={'Applications'}
      source={loadApplications}
      withAll={false}
      placeholder={'Select application'}
      required={true}
      {...props}
    />
  );
};

export const NetworksFilter = (props) => {
  return (
    <Filter.MultiSelect
      name={FILTER_NETWORKS}
      title={'Network'}
      source={loadNetworks}
      depends={FILTER_DEPENDENCIES[FILTER_NETWORKS]}
      withAll={false}
      placeholder={'Select network'}
      required={true}
      {...props}
    />
  );
};

export const PlatformsFilter = (props) => {
  return (
    <Filter.MultiSelect
      name={FILTER_PLATFORMS}
      title={'Platform'}
      source={loadPlatforms}
      depends={FILTER_DEPENDENCIES[FILTER_PLATFORMS]}
      withAll={false}
      placeholder={'Select platform'}
      required={true}
      {...props}
    />
  );
};

const isAffiliateOptionDisabled = (option, selectedOptions) => {
  const selectedOptionsIds = selectedOptions.map(({ id }) => id);

  if (selectedOptionsIds.length) {
    return (
      selectedOptionsIds.length === 8 && !selectedOptionsIds.includes(option.id)
    );
  }
  return false;
};

export const AffiliatesFilter = (props) => {
  return (
    <Filter.MultiSelect
      name={FILTER_AFFILIATES}
      title={'Affiliate'}
      source={loadAffiliates}
      depends={FILTER_DEPENDENCIES[FILTER_AFFILIATES]}
      isOptionDisabled={isAffiliateOptionDisabled}
      withSelectAll={false}
      withAll={false}
      placeholder={'Select affiliate'}
      required={true}
      {...props}
    />
  );
};

export const RealCountriesFilter = (props) => {
  return (
    <Filter.MultiSelect
      name={FILTER_REAL_COUNTRIES}
      title={'Real Country'}
      source={loadRealCountries}
      withAll={false}
      placeholder={'Select real country'}
      {...props}
    />
  );
};

export default {
  RegistrationPeriod: RegistrationPeriodFilter,
  Applications: ApplicationsFilter,
  Networks: NetworksFilter,
  Platforms: PlatformsFilter,
  Affiliates: AffiliatesFilter,
  RealCountries: RealCountriesFilter,
};
